import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';
import { invalidateAllAutomationQueries } from '../../queries/useAutomationQuery';
import { invalidateAllContactAutomationsQueries } from '../../queries/useContactAutomationsQuery';

interface Params {
	stepStatusId: string;
	attachmentId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useRemoveAutomationStepAttachmentMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAutomationStepStatus<Api.IEmailAutomationStep>, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ stepStatusId, attachmentId, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationStepStatus<Api.IEmailAutomationStep>>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `Automation/Step/${encodeURIComponent(stepStatusId)}/Attachment/${encodeURIComponent(attachmentId)}`,
					impersonationContext,
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess: (data, variables) => {
			invalidateAllAutomationQueries();
			invalidateAllContactAutomationsQueries();
			onSuccess?.(data, variables);
		},
	});
}
